import { Tenant } from 'apprise-core/tenant';
import { useTenantClone } from 'apprise-frontend-iam/tenant/context';
import { useRouting } from 'apprise-ui/utils/routing';
import { useNewTenant } from './model';

export const tenantRoute = "/tenant"


export const useTenantRouting = () => {

    const clone = useTenantClone()
    const routing = useRouting()
    const newTenant = useNewTenant()


    const self = {

        listRoute: () => tenantRoute

        ,

        detailRoute: (id: string) => `${tenantRoute}/${id}`

        ,

        innerDetailRoute: (id: string) => `${tenantRoute}/${id}${routing.query()}`

        ,

        newDetailRoute: () => `${tenantRoute}/new`


        ,


        userInTenantRoute: (tenant: string, id: string) => `${self.detailRoute(tenant)}/user/${id}`

        ,


        routeToList: () => routing.routeTo(self.listRoute())

        ,

        routeToDetail: (id: string) => routing.routeTo(self.detailRoute(id))

        ,

        routeToNewDetail: (tenant?: Tenant) => {

            tenant? clone.setQuietly(s => s.clone = tenant) : clone.resetQuietly()
            
            routing.routeTo(self.newDetailRoute())
        
        }

 
        ,


        nextTenant: () => clone.get().clone ?? newTenant()


    }

    return self;
}